import { motion } from "framer-motion";

export const FadeUp = ({
    children,
    delay = 0,
    y = 24,
    duration = 0.6,
    className = "",
    as: Component = "div",
    once = true,
}) => {
    const MotionComp = motion[Component] || motion.div;
    return (
        <MotionComp
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{
                duration,
                delay,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
        >
            {children}
        </MotionComp>
    );
};

export default FadeUp;
